document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  // --- Recommended small perf tweaks ---
  // Refresh after images/fonts finish to ensure correct start/end points
  window.addEventListener("load", () => ScrollTrigger.refresh());
  // Avoid stale values on resize/rotation
  ScrollTrigger.addEventListener("refreshInit", () => {
    // You can add layout recalcs here if needed
  });

  const mm = gsap.matchMedia();

  // Reduced-motion: keep it accessible (prefers-reduced-motion)
  mm.add("(prefers-reduced-motion: reduce)", () => {
    // Fade-only, no scrubbing, minimal movement
    const fadeIn = (target) =>
      gsap.from(target, {
        opacity: 0,
        duration: 0.6,
        ease: "power2.out",
        scrollTrigger: {
          trigger: target,
          start: "top 90%",
          toggleActions: "play none none reverse",
        },
      });

    fadeIn(".mateIntroSectionLeft");
    fadeIn(".mateDrapes h1");
    fadeIn(".mateDrapes p");
    fadeIn(".mateDrapes .category-slider");
    fadeIn(".whyMateIntro span");
    fadeIn(".whyMateIntro h1");
    document.querySelectorAll(".whyMateCard").forEach(fadeIn);
    fadeIn(".bespokeServicesLeft .bespokeTag");
    fadeIn(".bespokeServicesLeft h1");
    fadeIn(".bespokeServicesLeft p");
    fadeIn(".bespokeServicesRight img");
    fadeIn(".whyBespokeServicesContent h1");
    document.querySelectorAll(".whyBespokeCard").forEach(fadeIn);
    fadeIn(".fourStepRitual > h1");
    document.querySelectorAll(".fourStepRitualStep").forEach(fadeIn);
    fadeIn(".btnBookConsultation");

    // Disable parallax on video for reduced motion
    ScrollTrigger.getAll().forEach((st) => st.refresh());
  });

  // Mobile & tablet (<= 1023px): lighter distances, minimal scrubbing
  mm.add("(max-width: 1023px)", () => {
    // Helpers
    const fadeUp = (
      target,
      { y = 60, start = "top 90%", end = "top 70%" } = {}
    ) =>
      gsap.from(target, {
        y,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: {
          trigger: target,
          start,
          end,
          // scrubbing is heavy on mobile; prefer play/reverse
          scrub: false,
          toggleActions: "play none none reverse",
          invalidateOnRefresh: true,
        },
      });

    // --- MateIntro Right Column (images) ---
    const leftColumn = document.querySelectorAll(
      ".mateIntroSectionRight > .flex:first-child img"
    );
    const rightColumn = document.querySelectorAll(
      ".mateIntroSectionRight > .flex:last-child img"
    );
    gsap.from(leftColumn, {
      y: 60,
      opacity: 0,
      stagger: 0.15,
      duration: 0.8,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".mateIntroSectionRight",
        start: "top 92%",
        toggleActions: "play none none reverse",
      },
    });
    gsap.from(rightColumn, {
      y: -60,
      opacity: 0,
      stagger: 0.15,
      duration: 0.8,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".mateIntroSectionRight",
        start: "top 92%",
        toggleActions: "play none none reverse",
      },
    });

    // --- MateIntro Left Section ---
    fadeUp(".mateIntroSectionLeft", {
      y: 70,
      start: "top 92%",
      end: "top 75%",
    });

    // --- MateDrapes Section ---
    fadeUp(".mateDrapes h1", { y: 60 });
    fadeUp(".mateDrapes p", { y: 70, start: "top 92%", end: "top 72%" });
    fadeUp(".mateDrapes .category-slider", { y: 80 });

    // --- Video BG Parallax (gentle or off on mobile) ---
    gsap.to(".videoBG", {
      y: -80, // much smaller parallax for smoother mobile
      ease: "none",
      scrollTrigger: {
        trigger: ".videoBG",
        start: "top bottom",
        end: "bottom top",
        scrub: 0.3, // light scrub is OK here
        invalidateOnRefresh: true,
      },
    });

    // --- Why Mate Intro ---
    fadeUp(".whyMateIntro span", { y: 40 });
    fadeUp(".whyMateIntro h1", { y: 60 });

    // --- Why Mate Cards ---
    document.querySelectorAll(".whyMateCard").forEach((card, index) => {
      const direction = index % 2 === 0 ? 50 : -50;
      gsap.from(card, {
        y: direction,
        opacity: 0,
        duration: 0.7,
        ease: "power3.out",
        scrollTrigger: {
          trigger: card,
          start: "top 92%",
          toggleActions: "play none none reverse",
        },
      });
    });

    // --- Bespoke Services Left ---
    fadeUp(".bespokeServicesLeft .bespokeTag", { y: 35 });
    fadeUp(".bespokeServicesLeft h1", { y: 55 });
    fadeUp(".bespokeServicesLeft p", { y: 65 });

    // --- Bespoke Services Right Image ---
    gsap.from(".bespokeServicesRight img", {
      x: 80,
      scale: 1.05,
      opacity: 0,
      duration: 0.8,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".bespokeServicesRight",
        start: "top 92%",
        toggleActions: "play none none reverse",
        invalidateOnRefresh: true,
      },
    });

    // --- Why Bespoke heading + cards ---
    fadeUp(".whyBespokeServicesContent h1", { y: 55 });
    document.querySelectorAll(".whyBespokeCard").forEach((card, index) => {
      const direction = index % 2 === 0 ? 50 : -50;
      gsap.from(card, {
        y: direction,
        opacity: 0,
        duration: 0.7,
        ease: "power3.out",
        scrollTrigger: {
          trigger: card,
          start: "top 92%",
          toggleActions: "play none none reverse",
        },
      });
    });

    // --- Four Step Ritual ---
    fadeUp(".fourStepRitual > h1", { y: 55 });

    const cornerAnimationsMobile = [
      { x: -70, y: -70 },
      { x: 70, y: -70 },
      { x: -70, y: 70 },
      { x: 70, y: 70 },
    ];
    document.querySelectorAll(".fourStepRitualStep").forEach((card, i) => {
      gsap.from(card, {
        x: cornerAnimationsMobile[i]?.x ?? 0,
        y: cornerAnimationsMobile[i]?.y ?? 0,
        opacity: 0,
        duration: 0.7,
        ease: "power3.out",
        scrollTrigger: {
          trigger: card,
          start: "top 92%",
          toggleActions: "play none none reverse",
        },
      });
    });

    // --- CTA Button ---
    fadeUp(".btnBookConsultation", { y: 60, start: "top 95%", end: "top 75%" });
  });

  // Desktop (>= 1024px): your original feel, with tiny resiliency tweaks
  mm.add("(min-width: 1024px)", () => {
    const leftColumn = document.querySelectorAll(
      ".mateIntroSectionRight > .flex:first-child img"
    );
    const rightColumn = document.querySelectorAll(
      ".mateIntroSectionRight > .flex:last-child img"
    );

    gsap.from(leftColumn, {
      y: 100,
      opacity: 0,
      stagger: 0.2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".mateIntroSectionRight",
        start: "top 80%",
        end: "bottom 50%",
        scrub: true,
        invalidateOnRefresh: true,
      },
    });

    gsap.from(rightColumn, {
      y: -100,
      opacity: 0,
      stagger: 0.2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".mateIntroSectionRight",
        start: "top 80%",
        end: "bottom 50%",
        scrub: true,
        invalidateOnRefresh: true,
      },
    });

    gsap.from(".mateIntroSectionLeft", {
      y: 120,
      opacity: 0,
      ease: "power3.out",
      duration: 1.2,
      scrollTrigger: {
        trigger: ".mateIntroSectionLeft",
        start: "top 85%",
        end: "top 50%",
        scrub: true,
        invalidateOnRefresh: true,
      },
    });

    gsap.from(".mateDrapes h1", {
      y: 100,
      opacity: 0,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".mateDrapes",
        start: "top 80%",
        end: "top 50%",
        scrub: true,
      },
    });

    gsap.from(".mateDrapes p", {
      y: 120,
      opacity: 0,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".mateDrapes",
        start: "top 75%",
        end: "top 45%",
        scrub: true,
      },
    });

    gsap.from(".mateDrapes .category-slider", {
      y: 150,
      opacity: 0,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".mateDrapes .category-slider",
        start: "top 85%",
        end: "top 55%",
        scrub: true,
      },
    });

    // Video BG parallax (kept strong on desktop)
    gsap.to(".videoBG", {
      y: -300,
      ease: "none",
      scrollTrigger: {
        trigger: ".videoBG",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
        invalidateOnRefresh: true,
      },
    });

    gsap.from(".whyMateIntro span", {
      y: -50,
      opacity: 0,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".whyMateIntro",
        start: "top 85%",
        end: "top 65%",
        scrub: true,
      },
    });

    gsap.from(".whyMateIntro h1", {
      y: 120,
      opacity: 0,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".whyMateIntro",
        start: "top 80%",
        end: "top 50%",
        scrub: true,
      },
    });

    document.querySelectorAll(".whyMateCard").forEach((card, index) => {
      const direction = index % 2 === 0 ? 100 : -100;
      gsap.from(card, {
        y: direction,
        opacity: 0,
        ease: "power3.out",
        scrollTrigger: {
          trigger: card,
          start: "top 85%",
          end: "top 60%",
          scrub: true,
          invalidateOnRefresh: true,
        },
      });
    });

    gsap.from(".bespokeServicesLeft .bespokeTag", {
      y: 50,
      opacity: 0,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".bespokeServicesContent",
        start: "top 85%",
        end: "top 60%",
        scrub: true,
      },
    });

    gsap.from(".bespokeServicesLeft h1", {
      y: 80,
      opacity: 0,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".bespokeServicesContent",
        start: "top 80%",
        end: "top 55%",
        scrub: true,
      },
    });

    gsap.from(".bespokeServicesLeft p", {
      y: 100,
      opacity: 0,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".bespokeServicesContent",
        start: "top 75%",
        end: "top 50%",
        scrub: true,
      },
    });

    gsap.from(".bespokeServicesRight img", {
      x: 150,
      scale: 1.1,
      opacity: 0,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".bespokeServicesRight",
        start: "top 85%",
        end: "top 55%",
        scrub: true,
      },
    });

    gsap.from(".whyBespokeServicesContent h1", {
      y: 80,
      opacity: 0,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".whyBespokeServicesContent",
        start: "top 85%",
        end: "top 60%",
        scrub: true,
      },
    });

    document.querySelectorAll(".whyBespokeCard").forEach((card, index) => {
      const direction = index % 2 === 0 ? 100 : -100;
      gsap.from(card, {
        y: direction,
        opacity: 0,
        ease: "power3.out",
        scrollTrigger: {
          trigger: card,
          start: "top 90%",
          end: "top 60%",
          scrub: true,
        },
      });
    });

    gsap.from(".fourStepRitual > h1", {
      y: 80,
      opacity: 0,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".fourStepRitual",
        start: "top 85%",
        end: "top 60%",
        scrub: true,
      },
    });

    const cornerAnimations = [
      { x: -120, y: -120 },
      { x: 120, y: -120 },
      { x: -120, y: 120 },
      { x: 120, y: 120 },
    ];
    document.querySelectorAll(".fourStepRitualStep").forEach((card, i) => {
      gsap.from(card, {
        x: cornerAnimations[i].x,
        y: cornerAnimations[i].y,
        opacity: 0,
        ease: "power3.out",
        scrollTrigger: {
          trigger: card,
          start: "top 90%",
          end: "top 60%",
          scrub: true,
          invalidateOnRefresh: true,
        },
      });
    });

    gsap.from(".btnBookConsultation", {
      y: 100,
      opacity: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: ".btnBookConsultation",
        start: "top 90%",
        end: "top 65%",
        scrub: true,
      },
    });
  });
});
